import { render } from "./hotelDeals.vue?vue&type=template&id=5a9bd97a&scoped=true"
import script from "./hotelDeals.vue?vue&type=script&lang=js"
export * from "./hotelDeals.vue?vue&type=script&lang=js"

import "./hotelDeals.vue?vue&type=style&index=0&id=5a9bd97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9bd97a"]])

export default __exports__